import Modal from "components/Modal";
import { STUDENT_EMAIL } from "constants/config";
import useLabels from "hooks/useLabels";
import { useRouter } from "next/router";

type NoEduEmailModalProps = {
  open?: boolean;
  onClose: () => void;
};

/**
 * @component NoEduEmailModal
 * @description Modal shown when you try to claim a student discount with a non-edu email address
 * @example
 * return (
 *   <NoEduEmailModal
 *    open={true}
 *    onClose={fn}
 *   />
 * )
 */
function NoEduEmailModal({ open, onClose }: NoEduEmailModalProps) {
  const router = useRouter();

  const [modalLabels] = useLabels("student-discount.no-edu-email-modal");

  const handleClickSupport = () => {
    if (window && window.Intercom) {
      window.Intercom("show");
    }

    if (onClose) {
      onClose();
    }
  };

  const handleGoToAccount = () => {
    router.push("/account/");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      buttonText={modalLabels["go-to-account"]}
      onButtonClicked={handleGoToAccount}
      title={modalLabels["title"]}
    >
      <h2 className="base-md">{modalLabels["have-student-email-title"]}</h2>
      <ol className="pl-6 mt-2 list-decimal marker:text-fg-muted sm-normal">
        {(modalLabels["have-account-steps"] as string[]).map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      <h2 className="base-md mt-4">
        {modalLabels["do-not-have-student-email-title"]}
      </h2>
      <p className="my-2">
        <span>{modalLabels["do-not-have-student-email-subtitle-1"]}&nbsp;</span>
        <a
          href={`mailto:${STUDENT_EMAIL}`}
          className="underline text-accent-fg-base"
        >
          {STUDENT_EMAIL}
        </a>
        <span>&nbsp;{modalLabels["do-not-have-student-email-subtitle-2"]}</span>
      </p>
      <ol className="pl-6 mt-2 list-decimal marker:text-fg-muted sm-normal">
        {(modalLabels["do-not-have-account-steps"] as string[]).map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
    </Modal>
  );
}

export default NoEduEmailModal;
